import React, { useEffect, useState } from "react";

const AnimatedCounter = ({ value, duration = 1000 }) => {
  const [count, setCount] = useState(0);
  const isDollar = typeof value === "string" && value.trim().startsWith("$");
  const numericString = typeof value === "string" ? value.replace(/[^0-9.]/g, "") : value;
  const target = parseFloat(numericString) || 0;

  useEffect(() => {
    let startTimestamp = null;
    let animationFrameId;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      // Ease-out cubic formula: 1 - (1 - t)^3
      const easeOut = 1 - Math.pow(1 - progress, 3);
      setCount(easeOut * target);

      if (progress < 1) {
        animationFrameId = requestAnimationFrame(step);
      }
    };

    animationFrameId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animationFrameId);
  }, [target, duration]);

  if (isDollar) {
    return `$${count.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  if (!Number.isInteger(target)) {
    return count.toFixed(2);
  }
  return Math.round(count);
};

export default AnimatedCounter;
